var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sa-info"},[_c('div',{staticClass:"sa-info-dot"}),_c('div',{staticClass:"sa-info-body"})])
}]

export { render, staticRenderFns }